var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"product-item-modal","title":_vm.product ? _vm.product.label : '',"hide-footer":""}},[(_vm.product)?_c('div',[_c('ProductItem',{attrs:{"product":_vm.product}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }